import { css } from '@emotion/react';
import { ColDef } from 'ag-grid-community';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { AgTableWithBaseStyle } from '../../../../components/AgTable/AgTable2';
import { agForesightCompactTheme } from '../../../../theme/ag-foresight';
import { useShowSummaryV2 } from '../useShowSummaryV2';
import { getColorByPosition } from './OwnershipTimelineChart';
import { stackedBarsJ, useHoldingsAsOfDate } from './state';
import { getHoldingsColDefs, getHoldingsColDefsV2 } from './holdingsColDefs';

const gridContainer = css`
  padding: 0 0.5rem 0.5rem;
`;

// Compact theme (tighter spacing, 12px header) plus a smaller cell font so the grid
// matches the surrounding panel rather than the larger default grid size.
const holdingsGridTheme = agForesightCompactTheme.withParams({ fontSize: 12 });

const defaultColDef: ColDef = {
  sortable: true,
  resizable: true,
  flex: 1,
};

interface IHoldingsGridProps {
  companyId: number;
}

export function HoldingsGrid({ companyId }: IHoldingsGridProps) {
  const showSummaryV2 = useShowSummaryV2();
  const holdings = useHoldingsAsOfDate(companyId);
  const bars = useAtomValue(stackedBarsJ(companyId));

  const columnDefs = useMemo(
    () => (showSummaryV2 ? getHoldingsColDefsV2(getColorByPosition(bars)) : getHoldingsColDefs()),
    [showSummaryV2, bars]
  );

  return (
    <div css={gridContainer}>
      <AgTableWithBaseStyle
        columnDefs={columnDefs}
        rowData={holdings}
        defaultColDef={defaultColDef}
        domLayout='autoHeight'
        theme={holdingsGridTheme}
      />
    </div>
  );
}
